/* ============================================================
   KORENA - motion layer (Dossier).
   Scroll-reveal via IntersectionObserver. Tags section children
   with [data-reveal] + a stagger index, then reveals them as they
   enter the viewport. No window scroll listeners. If a visitor
   prefers reduced motion, nothing is tagged (content stays fully
   visible). The hero entrance is pure CSS (see korena-motion.css);
   this file only handles scroll reveals.
   ============================================================ */
(function () {
  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduce) return; // leave everything visible, no animation

  function ready(fn) {
    if (document.readyState !== "loading") { fn(); }
    else { document.addEventListener("DOMContentLoaded", fn); }
  }

  ready(function () {
    // [selector, stagger?] - parents listed before their content so the
    // closest() nesting guard skips descendants of an already-tagged node.
    var SETS = [
      [".certstrip__i", true],
      [".sec-rule__head", false],
      [".plate", true],
      [".exclusives__card", false],
      [".effect", true],
      [".protocol__img", false],
      [".protocol__body", false],
      [".standard__head", false],
      [".standard__intro", false],
      [".k-clause", true],
      [".shop__gallery", false],
      [".shop__main", false],
      [".faq .sec-title", false],
      [".faq .k-acc__item", true],
      [".footer__top > *", true]
    ];

    var tagged = [];
    SETS.forEach(function (set) {
      var sel = set[0], stagger = set[1];
      var els = document.querySelectorAll(sel);
      Array.prototype.forEach.call(els, function (el, i) {
        if (el.hasAttribute("data-reveal")) return;
        if (el.closest("[data-reveal]")) return; // avoid nested reveals
        el.setAttribute("data-reveal", "");
        if (stagger) el.style.setProperty("--i", i % 8);
        tagged.push(el);
      });
    });

    if (!tagged.length) return;

    if (!("IntersectionObserver" in window)) {
      tagged.forEach(function (el) { el.classList.add("is-in"); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add("is-in");
          io.unobserve(e.target);
        }
      });
    }, { root: null, rootMargin: "0px 0px -8% 0px", threshold: 0.12 });

    tagged.forEach(function (el) { io.observe(el); });

    // Failsafe: never leave content hidden if the observer misfires.
    setTimeout(function () {
      tagged.forEach(function (el) { el.classList.add("is-in"); });
    }, 4500);
  });
})();
